import * as mainTerms from '../mainTerms';
export const query = {
    campaign: {
        campaignName: mainTerms.Setting.campaign.default + ' 명 입력',
    },
    adset: {
        adsetName: mainTerms.Setting.adset.default + ' 명 입력',
    },
    ad: {
        adName: mainTerms.Setting.ad.default + ' 명 입력',
    },
    audience: {
        audienceName: mainTerms.Setting.audience.default + ' 명 입력',
    },
    adFolder: {
        adFolderName: mainTerms.Setting.adFolder.default + ' 명 입력',
    },
}